// One-tap add for the cart offer block (snippets/cart-offer.liquid).
document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-cart-offer-add]');
  if (!btn) return;
  event.preventDefault();
  btn.setAttribute('aria-busy', 'true');
  const error = btn.closest('.cart-offer')?.querySelector('.cart-offer__error');
  const root = window.Shopify?.routes?.root || '/';
  try {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: ['cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add it');
    // Never leave a full-price item behind: if the discount did not apply, undo the add.
    const variantId = Number(btn.dataset.variantId);
    const offerPrice = Number(btn.dataset.offerPrice);
    const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const line = cart.items.find((item) => item.variant_id === variantId);
    const discounted = line && (line.final_price <= offerPrice || line.final_line_price < line.original_line_price);
    if (!discounted) {
      if (line) {
        await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity - 1 }),
        });
      }
      throw new Error('This offer is not active right now. Nothing was added to your cart.');
    }
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return;
    }
    const bubble = document.getElementById('cart-icon-bubble');
    const bubbleHtml = data.sections && data.sections['cart-icon-bubble'];
    if (bubble && bubbleHtml) {
      const fresh = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-offer', cartData: data });
    }
  } catch (err) {
    btn.removeAttribute('aria-busy');
    if (error) {
      error.textContent = err.message;
      error.hidden = false;
    }
  }
});
